/**
 * Shared "Timeframe" select param for indicators that fold Daily / Weekly
 * (/ Monthly) into ONE def instead of one def per timeframe.
 *
 * Default = Daily (0). The default-param column reads the precomputed daily
 * field (`def.panelKey`); a changed `tf` reads the precomputed weekly / monthly
 * column INSTANTLY via the timeframe resolver in `dynamicIndicatorColumns`
 * (no `/api/scanner/indicator` recompute) — see `TF_PRECOMPUTED` there.
 */
import type { SharedParam } from "../types";

export const TF_PARAM = "tf";

export const TF_DW: SharedParam = {
  id: TF_PARAM,
  label: "Timeframe",
  kind: "select",
  default: 0,
  choices: [
    { value: 0, label: "Daily" },
    { value: 1, label: "Weekly" },
  ],
};

export const TF_DWM: SharedParam = {
  id: TF_PARAM,
  label: "Timeframe",
  kind: "select",
  default: 0,
  choices: [
    { value: 0, label: "Daily" },
    { value: 1, label: "Weekly" },
    { value: 2, label: "Monthly" },
  ],
};
